function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IarrowRight2 = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28957 15.8805L13.1696 12.0005L9.28957 8.12047C8.89957 7.73047 8.89957 7.10047 9.28957 6.71047C9.67957 6.32047 10.3096 6.32047 10.6996 6.71047L15.2896 11.3005C15.6796 11.6905 15.6796 12.3205 15.2896 12.7105L10.6996 17.3005C10.3096 17.6905 9.67957 17.6905 9.28957 17.3005C8.90957 16.9105 8.89957 16.2705 9.28957 15.8805Z",
    fill: "#495057"
  }));
});